// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-21f31da6]:export{primaryColor:#64b5f6;secondaryColor:#003c60;accentColor:#c41230}", ""]);
// Exports
module.exports = exports;
